import { useMutation, useQueryClient } from "react-query";
import { useAuth } from "../useAuth";
import { toast } from "react-toastify";
import ConfirmDialog from "../../components/ConfirmDialogue";
import CopyShare from "../../components/utils/CopyShare";

// ------------------------
// React hook
export const useCreateFormLink = () => {
  const { backendUrl } = useAuth();
  const queryClient = useQueryClient();

  const createFormLink = async payload => {
    const res = await fetch(`${backendUrl}/api/share-links`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include", // send cookies/session
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.message || "Failed to create share link");
    }

    return await res.json(); // returns created link(s)
  };

  return useMutation(createFormLink, {
    onSuccess: data => {
      console.log("Share link(s) created:", data);

      // Optional: refresh any share-link lists
      queryClient.invalidateQueries("SHARE_LINKS");

      ConfirmDialog({
        title: "links Shared",
        description: (
          <ul>
            {data.data.map(link => (
              <li key={link.token}>
                <div className="mb-2 d-flex gap-3">
                  <span>{link.entityLink}</span>{" "}
                  <span>
                    <CopyShare text={link.entityLink} />
                  </span>
                </div>
              </li>
            ))}
          </ul>
        ),
        choice: false,
      });
    },
    onError: err => {
      console.error("Failed to create share link:", err.message);
      toast.error(`Failed to create share link: ${err.message}`);
    },
  });
};
